import React from "react";
import { Image, ImageLinkWrapper, Paragraph, Title, Wrapper } from "./styles";
import howToRentImg from "../../../../assets/pages/PropertyDetails/5. Loan Request.png";
import { Link } from "react-router-dom";

function HowToRentCard() {
  return (
    <Wrapper>
      <ImageLinkWrapper>
        <Image src={howToRentImg} />
        <Link to="/advertise-property" target="_blank">
          Anunciar agora
        </Link>
      </ImageLinkWrapper>
      <Title>Como alugar este imóvel</Title>
      <Paragraph>
        É necessário comprovar renda mensal de 3X o valor do aluguel +
        condomínio + IPTU. A renda pode ser composta por até 4 pessoas físicas.
        <br />
        <br />
        Contratos administrados pela 7Cantos possuem garantia facilitada, sem
        necessidade de fiador ou caução.
      </Paragraph>
    </Wrapper>
  );
}

export default HowToRentCard;
